import { useEffect } from 'react'
import styles from '../intercom/intercom.sass'

let counter = 0

/**
 * Hides intercom button
 */
export function useIntercomHider() {
  useEffect(() => {
    if (counter === 0) {
      document.body.classList.add(styles.hide)
    }

    counter++

    return () => {
      if (counter === 1) {
        document.body.classList.remove(styles.hide)
      }

      counter--
    }
  }, [])
}
